import type { AgGridReact } from 'ag-grid-react';
import classNames from 'classnames';
import { FC, ReactElement } from 'react';
import styled from 'styled-components';

const WrapperDiv = styled.div`
  .ag-cell[col-id='quoteId'],
  .ag-cell[col-id='tradeId'],
  .ag-cell[col-id='addToOrderBasket'] {
    padding-left: 0;
    padding-right: 0;

    & .ag-group-expanded,
    & .ag-group-contracted {
      padding: var(--spacer-4);
    }
  }

  .ag-aria-description-container {
    display: none;
  }
`;

export const GridWrapperWithTheme: FC<{
  children: ReactElement<AgGridReact>;
  className?: string;
  condensed: boolean;
  e2e?: string;
}> = ({ children, condensed, className, e2e }) => {
  return (
    <WrapperDiv
      className={classNames('h-100', className, {
        'ag-theme-sg-bootstrap': !condensed,
        'ag-theme-sg-bootstrap-condensed': condensed,
      })}
      data-e2e={e2e}
    >
      {children}
    </WrapperDiv>
  );
};
